import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Response, ResponseContentType} from '@angular/http';
import "rxjs/Rx";
import 'rxjs/add/operator/toPromise';
import {Observable} from "rxjs/Observable";


@Injectable()
export class HttpService {

  constructor(private http: HttpClient) {
  }

  get(url: string, params?: HttpParams, responseType?): Observable<any> {
    return this.http.get(url, {params: params, responseType: responseType})
      .map(this.extractAnyData)
      .catch(this.handleError);
  }


  post(url: string, body: any, params: HttpParams): Observable<Response> {
    let options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };
    return this.http.post(url, body, options)
      .map(this.extractAnyData)
      .catch(this.handleError);
  }

  delete(url: string, params: HttpParams): Observable<Response> {
    let options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };
    return this.http.delete(url, options)
      .map(this.extractAnyData)
      .catch(this.handleError);
  }

  upload(url: string, formData: FormData, params?: HttpParams): Observable<Response> {
    //multipart/form-data
    let options = {
      reportProgress: false,
      params: params
    };
    return this.http.post(url, formData, options)
      .map(this.extractAnyData)
      .catch(this.handleError);
  }

  extractAnyData(res: any) {
    return <any>res;
  }

  handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

}
